import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import alarmsActions from '@state/inverters/actions';

function useAccionesAlarma() {

  const dispatch = useDispatch();

  const actions = useSelector(({ inverters: a }) => a.createEditValues.actions);

  const actionsTypeInit = useMemo(
    () => ({
      // webhook: { type: 'webhook', params: { urls: [''] } },
      email: { type: 'email', params: { recipients: [''] } },
    }),
    [],
  );

  const missingTypes = useMemo(() => {

    const currentTypes = actions.map(({ type }) => type);
    return Object.values(actionsTypeInit).filter(({ type }) => !currentTypes.includes(type));

  }, [actions, actionsTypeInit]);

  const addGenericItem = useCallback(
    (index, paramsTarget) => {

      const newActions = [...actions];
      const actionTarget = newActions[index];
      const currentUrls = actionTarget.params[paramsTarget];
      actionTarget.params[paramsTarget] = [...currentUrls, ''];
      dispatch(alarmsActions.changeCreateEditValuesAction(index, actionTarget));

    },
    // eslint-disable-next-line
    [actions]
  );

  const removeGenericItem = useCallback(
    (index, indexItem, paramsTarget) => {

      const newActions = [...actions];
      const actionTarget = newActions[index];
      actionTarget.params[paramsTarget].splice(indexItem, 1);
      dispatch(alarmsActions.changeCreateEditValuesAction(index, actionTarget));

    },
    // eslint-disable-next-line
    [actions]
  );

  const onChangeGenericItem = useCallback(
    (index, indexItem, str, paramsTarget) => {

      const newActions = [...actions];
      const actionTarget = newActions[index];
      actionTarget.params[paramsTarget][indexItem] = str;
      dispatch(alarmsActions.changeCreateEditValuesAction(index, actionTarget));

    },
    // eslint-disable-next-line
    [actions]
  );

  const addUrl = useCallback((index) => addGenericItem(index, 'urls'), [addGenericItem]);
  const removeUrl = useCallback((index, indexUrl) => removeGenericItem(index, indexUrl, 'urls'), [
    removeGenericItem,
  ]);
  const onChangeUrl = useCallback(
    (index, indexUrl, urlStr) => onChangeGenericItem(index, indexUrl, urlStr, 'urls'),
    [onChangeGenericItem],
  );

  const addEmail = useCallback((index) => addGenericItem(index, 'recipients'), [addGenericItem]);
  const removeEmail = useCallback(
    (index, indexEmail) => removeGenericItem(index, indexEmail, 'recipients'),
    [removeGenericItem],
  );
  const onChangeEmail = useCallback(
    (index, indexEmail, urlStr) => onChangeGenericItem(index, indexEmail, urlStr, 'recipients'),
    [onChangeGenericItem],
  );

  const addAction = useCallback(() => {

    const [firstMissing] = missingTypes;
    if (firstMissing) dispatch(alarmsActions.addCreateEditValuesAction(firstMissing));

    // eslint-disable-next-line
  }, [actions, missingTypes]);

  const removeAction = useCallback((index) => {

    dispatch(alarmsActions.removeCreateEditValuesAction(index));
    // eslint-disable-next-line
  }, []);

  const onChangeType = useCallback(
    (index, value) => {

      const newActions = [...actions];
      let actionTarget = newActions[index];
      actionTarget = actionsTypeInit[value] || null;

      dispatch(alarmsActions.changeCreateEditValuesAction(index, actionTarget));

    },
    // eslint-disable-next-line
    [actions, actionsTypeInit]
  );

  return {
    actions,
    addAction,
    removeAction,
    onChangeType,
    missingTypes,
    urlActions: {
      addUrl,
      removeUrl,
      onChangeUrl,
    },
    emailActions: {
      addEmail,
      removeEmail,
      onChangeEmail,
    },
  };

}

export default useAccionesAlarma;
